import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCards";
import Particle from "../components/Common/Particle";
import editor from "../Assets/Projects/codeEditor.png";
import chatify from "../Assets/Projects/chatify.png";
import bitsOfCode from "../Assets/Projects/blog.png";

function Projects() {
    return (
        <Container fluid as="section" className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    My Recent <strong className="purple">Works </strong>
                </h1>
                <p className="project-subtitle">
                    Here are a few projects I've worked on recently.
                </p>
                <Row
                    style={{ justifyContent: "center", paddingBottom: "10px" }}
                >
                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={bitsOfCode}
                            isBlog={false}
                            title="WeatherScope"
                            description="A simple and intuitive weather web application that allows users to check the current weather conditions in a city or at their current location using geolocation. Built with React and powered by the OpenWeatherMap API to provide real-time, detailed weather information."
                            demoLink="https://weatherscope.vercel.app/"
                            ghLink="https://github.com/Siradio7/read_meteo"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={chatify}
                            isBlog={false}
                            title="MyContacts"
                            description="An android contact directory app, crafted following Orange Digital Center(ODC) training. Simplify managing your personal and professional contacts with a user-friendly interface."
                            ghLink="https://github.com/Siradio7/MyContacts"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={bitsOfCode}
                            isBlog={false}
                            title="MusicPlayer"
                            description="A sleek and intuitive music player built with JavaFX. Enjoy seamless playback, dynamic controls and playlist management for a personalized listening experience."
                            ghLink="https://github.com/Siradio7/music_player"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={editor}
                            isBlog={false}
                            title="MysteryWord"
                            description="Dive into the captivating world of our word guessing game with hidden letters: challenge your mind and uncover hidden words by deciphering clues, for a stimulating and entertaining gaming experience."
                            ghLink="https://github.com/Siradio7/MysteryWord"
                            demoLink="https://mystery-word.vercel.app/"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={bitsOfCode}
                            isBlog={false}
                            title="Fondation UNC"
                            description="This GitHub repository showcases the project I've developed for my university, aimed at streamlining same-day appointments with the founder. Managed exclusively by the founder's secretary and the founder themselves, the application offers a user-friendly interface for efficient appointment coordination. Dive into the source code to learn more about its functionality and implementation."
                            demoLink="https://fondation-unc.vercel.app/"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={bitsOfCode}
                            isBlog={false}
                            title="CoSportivo"
                            description="CoSportivo is an innovative web application that connects fans and athletes to facilitate carpooling to sporting events. Our platform allows fans to travel to matches together, share their passion, and reduce their carbon footprint."
                            demoLink="https://co-sportivo.vercel.app/"
                            ghLink="https://github.com/Siradio7/CoSportivo"
                        />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Projects;
